import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { CustomModal } from "../../../../revampComponents/Atom/Modals";
import { CreateEventProfileApi, EditEventProfileApi } from "../../../../revampCRUD/eventProfile.curd";
import { toggleBodyScroll } from "../../../../services/util";
import { errorToaster, successToaster } from "../../../../reusable/common";
import { APIStatusCode } from "../../../../services/util";
import { useHistory } from "react-router-dom";


const CreateEventProfileModal = ({ show, onClose, fetchEventProfiles, editProfile = false, manageProfileDetails = {}, fetchEventProfileDetails = () => { }, createProfile = false }) => {

    const [isApiLoading, setisApiLoading] = useState(false);
    const history = useHistory();
    const formik = useFormik({
        initialValues: {
            name: manageProfileDetails?.name ? manageProfileDetails?.name : "",
            description: manageProfileDetails?.description ? manageProfileDetails?.description : "",
        },
        validate: (values) => {
            const errors = {};
            if (!values.name.trim()) {
                errors.name = "Event Profile Name is required";
            }
            return errors;
        },
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            if (!editProfile) {
                createEventProfile(values);
            } else {
                editEventProfile(values);
            }
        },
    });

    useEffect(() => {
        if (editProfile && manageProfileDetails) {
            formik.setFieldValue("name", manageProfileDetails.name || "")
            formik.setFieldValue("description", manageProfileDetails.description || "")
        }
    }, [editProfile, manageProfileDetails]);

    const editEventProfile = async (values) => {
        setisApiLoading(true);
        try {
            const res = await EditEventProfileApi(manageProfileDetails.profile_id, values);
            if (res.status == APIStatusCode.STATUS_CODE_SUCCESS) {
                successToaster(res.data.message || "Event Profile editted successfully");
                toggleBodyScroll();
                fetchEventProfileDetails();
            } else {
                throw new Error("Unexpected response from API");
            }
        } catch (err) {
            console.error(err);
            errorToaster(err?.message);
        } finally {
            onClose();
            setisApiLoading(false);
        }
    };

    const createEventProfile = async (values) => {
        setisApiLoading(true);
        try {
            const res = await CreateEventProfileApi(values);
            if (res?.status == APIStatusCode?.STATUS_CODE_CREATED) {
                successToaster(res?.data?.message || "Event Profile created successfully");
                fetchEventProfiles();
                toggleBodyScroll();
                if (createProfile) {
                    history.push({
                        pathname: `/event-profile/${res?.data?.profile_id}/organizer-details`,
                    });
                }
            } else {
                throw new Error("Unexpected response from API");
            }
        } catch (err) {
            console.error(err);
            errorToaster(err?.message);
        } finally {
            if (!createProfile) {
                onClose();
                formik.resetForm();
            }
        }
    };

    const closeModal = () => {
        if (createProfile) {
            formik.resetForm();
        } else {
            formik.setFieldValue("name", manageProfileDetails?.name || "");
            formik.setFieldValue("description", manageProfileDetails?.description || "");
        }
        onClose();
    };
    return (
        <CustomModal
            openModal={show}
            isLoading={isApiLoading}
            setOpenModal={onClose}
            width="40%"
            onOkay={() => {
                formik.handleSubmit();
            }}
            onClose={closeModal}
            onCancel={closeModal}
            saveBtnDisabled={formik.isSubmitting || formik.errors.name}
            saveBtnContent={editProfile ? "Save" : "Create"}
            cancelBtnContent="Cancel"
            justifyContentForButtons="end"
            content={
                <div className="mx-3">
                    <div className="modal-header-create">
                        <span>{editProfile ? "Edit Event Profile Name and Description" : "Create Event Profile"}</span>
                    </div>

                    <div className="form-group">
                        <label htmlFor="name" className="label">
                            Event Profile Name <span className="required">*</span>
                        </label>
                        <input
                            id="name"
                            name="name"
                            type="text"
                            className="input"
                            placeholder="Enter event profile name"
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}

                        />
                        {formik.touched.name && formik.errors.name && (
                            <div className="error">{formik.errors.name}</div>
                        )}
                    </div>

                    <div className="form-group">
                        <label htmlFor="description" className="label">
                            Description
                        </label>
                        <input
                            id="description"
                            name="description"
                            type="text"
                            className="input"
                            placeholder="Enter description"
                            value={formik.values.description}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                    </div>

                    <style>{`
                        .modal-header-create {
                            font-size: 20px;
                            font-weight: 500;
                            margin-bottom: 18px;
                        }
                        .form-group {
                            margin-bottom: 18px;
                        }
                        .required {
                            color: #d32f2f;
                        }
                        .error {
                            color: #d32f2f;
                            font-size: 12px;
                            margin-top: 4px;
                        }
                        .modal-footer {
                            display: flex;
                            justify-content: flex-end;
                            gap: 12px;
                            margin-top: 18px;
                        }
                        .btn {
                            min-width: 100px;
                            padding: 8px 18px;
                            border-radius: 5px;
                            font-size: 1rem;
                            font-weight: 500;
                            cursor: pointer;
                            border: none;
                        }
                        .btn-primary {
                            background: #003366;
                            color: #fff;
                        }
                        .btn-outline {
                            background: #fff;
                            color: #003366;
                            border: 1.5px solid #003366;
                        }
                        .btn:disabled {
                            opacity: 0.6;
                            cursor: not-allowed;
                        }
                    `}</style>
                </div>
            }
        />
    );
};

export default CreateEventProfileModal;
